import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-loading-circle',
  templateUrl: './loading-circle.component.html',
  styleUrls: ['./loading-circle.component.scss'],
})
export class LoadingCircleComponent implements OnInit {

  @ViewChild('card', { read: ElementRef })
  card: ElementRef<HTMLInputElement>;


  ngOnInit() {
    setTimeout(() => {
      this.card.nativeElement.focus();
    }, 10);
  }

}
